module.exports = __webpack_public_path__ + "media/images/emblems/Trubschachen-coat_of_arms-7a08457e26dd0b0d49b94e0fbaa8c37c.svg";